import { defineMessages } from 'react-intl'

const scope = `procurify.components.CardholderSelect`

export default defineMessages({
  placeholderText: {
    id: `${scope}.placeholderText`,
    defaultMessage: 'Select a cardholder',
  },
})
